import { h } from 'preact'
import { useEffect, useRef } from 'preact/compat'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import WarningIcon from '../../../assets/icons/warning.svg'
import { DataDog } from '../../../datadog'
import styles from './ErrorMessage.module.scss'

const ErrorMessage = ({
  children,
  isShown = false,
  message = '',
  ...props
}) => {
  const isMsgAlreadyShownRef = useRef()

  useEffect(() => {
    if (isShown) {
      isMsgAlreadyShownRef.current = true
      DataDog.info(`Showing error message: ${message}`)
    } else if (isMsgAlreadyShownRef.current) {
      isMsgAlreadyShownRef.current = false
      DataDog.info(`Hiding error message: ${message}`)
    }
  }, [isShown])

  if (!isShown) {
    return null
  }

  const classes = classNames('payment-form__error-message', 'tenant-overrides-payment-error', styles.paymentError)

  return (
    <div className={classes} {...props}>
      <div className={styles.paymentError__container}>
        <img
          src={WarningIcon}
          alt="Warning icon"
          className={styles.paymentError__icon}
        />
        <div className={styles.paymentError__textContainer}>
          <div className={styles.paymentError__text}>
            {message}
          </div>
          <div className={styles.paymentError__children}>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

ErrorMessage.propTypes = {
  children: PropTypes.element,
  isShown: PropTypes.bool,
  message: PropTypes.string,
}

export default ErrorMessage
